<template>
  <div class="sort-by-small text-left text-xl-right mr-2">
    <div class="no-gutters d-flex pb-2">
      <span
        class="pr-2 text-muted text-uppercase text-size-small font-16 pt-1 text-nowrap">
        {{ $resourceString["common.accounts.Title.Sort"] }}
        </span>
      <select
        id="dropdown"
        class="font-16 pl-2 border-0 custom-dropdown"
        v-model="selectedOption"
        @change="handleDropdownChange"
      >
        <option
          v-for="(option, index) in options"
          :key="index"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { mapActions,mapGetters } from "vuex";

export default {
  data() {
    return {
      selectedOption: "UpdatedAt",
      options: [
        { value: "UpdatedAt", label: this.$resourceString['common.accounts.Label.LastModified'] },
        { value: "CreatedAt", label: this.$resourceString['common.accounts.Label.Newest'] },
        { value: "CreatedAtAscTrue", label: this.$resourceString['common.accounts.Label.Oldest'] },
        { value: "TitleAscTrue", label: this.$resourceString['common.accounts.Label.AtoZ'] },
        { value: "Title", label: this.$resourceString['common.accounts.Label.ZtoA'] }
      ]
    };
  },
  computed:{
    ...mapGetters({
  selectedTab: "myTray/getselectedTabName",

})
  },
  watch: {
    selectedTab: {
        handler: function () {
          this.selectedOption = "UpdatedAt"
        }
      }},
  methods: {
    ...mapActions({
      upadteSelectedSortby: "myTray/upadteSelectedSortby"
    }),

    handleDropdownChange() {
      this.upadteSelectedSortby(this.selectedOption);
    }
  }
};
</script>
